const DEFAULT_LOCALE = 'en-US';

const DATE_OPTIONS = { month: 'short', day: 'numeric', year: 'numeric' };
const TIME_OPTIONS = { hour: 'numeric', minute: '2-digit', hour12: true };

function toDate(value) {
  return value instanceof Date ? value : new Date(value);
}

/**
 * Returns `{ date, time }` strings localized to `locale`. Pass `i18n.language`
 * from useTranslation so RTL locales like Arabic format correctly and survive
 * bidi reordering when embedded in RTL UI.
 */
export function formatTimestamp(timestamp, locale = DEFAULT_LOCALE) {
  if (!timestamp) return { date: '-', time: '-' };
  try {
    const d = toDate(timestamp);
    return {
      date: d.toLocaleDateString(locale, DATE_OPTIONS),
      time: d.toLocaleTimeString(locale, TIME_OPTIONS),
    };
  } catch {
    return { date: '-', time: '-' };
  }
}

/**
 * Single-string replacement for `new Date(x).toLocaleString()`. Always pass
 * `i18n.language` so the format respects the user's chosen language.
 */
export function formatDateTime(timestamp, locale = DEFAULT_LOCALE, options) {
  if (!timestamp) return '';
  try {
    return toDate(timestamp).toLocaleString(locale, options);
  } catch {
    return '';
  }
}

/**
 * Single-string replacement for `new Date(x).toLocaleDateString()`. Pass
 * `i18n.language` so non-Latin locales format correctly.
 */
export function formatDate(timestamp, locale = DEFAULT_LOCALE, options) {
  if (!timestamp) return '';
  try {
    return toDate(timestamp).toLocaleDateString(locale, options);
  } catch {
    return '';
  }
}
